import Vue from 'vue'
import JwtService from '@/common/jwt.service'
import ApiService from '@/common/api.service'
import {
  SET_TOKEN,
  SET_USER_DATA,
  PURGE_AUTH,
  SET_USER_BANK_CARD,
  SET_USER_BANK_ACCOUNT,
  SET_EMPLOYEE_DATA,
  REMOVE_EMPLOYEE_BRANCH
} from '../mutations.types'
export default {
  [SET_TOKEN](state, token) {
    state.token = token
    state.isAuthenticated = true
    JwtService.saveToken(token)
    ApiService.setHeader()
  },
  [SET_USER_DATA](state, data) {
    // state.user = data
    if (data.avatar !== null) {
      data.avatar = `${data.avatar}`
    }
    data.userRole = data.roles[0].toLowerCase()
    if (!data.bank_card) {
      data.bank_card = {
        'card_number': '',
        'card_data': '',
        'card_name': ''
      }
    }
    if (!data.bank_account) {
      data.bank_account = {
        'account_number': '',
        'bik': '',
        'account_name': ''
      }
    }
    Vue.set(state, 'user', data)
  },
  [SET_EMPLOYEE_DATA](state, data) {
    Vue.set(state, 'employee', data)
  },
  [REMOVE_EMPLOYEE_BRANCH](state) {
    state.employee.company_branch = null
  },
  [SET_USER_BANK_CARD](state, data) {
    state.user.bank_card = data
  },
  [SET_USER_BANK_ACCOUNT](state, data) {
    state.user.bank_account = data
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false
    state.token = null
    state.user = {
      bank_card: {
        card_number: null,
        card_date: null,
        card_name: null
      },
      bank_account: {
        account_number: null,
        bik: null,
        account_name: null
      },
      email: '',
      id: null
    }
    state.userRole = null
    JwtService.destroyToken()
  },
  // two way data binds
  // form issue
  updateFirstName(state, first_name) {
    state.user.first_name = first_name
  }
}
